/**
 * Experiences Tab Content Component
 * Renders the experiences tab content for a response pair
 */

import React from 'react';
import { ExperienceCard } from '@/constants/chatScreenData';
import {
  spacing,
  typographyColors,
  typography,
  fontPrimary,
} from '@/design-system/utils';
import {
  NexgoExperiencesSection,
  ExperiencesLoadingPlaceholder,
} from '../../experiences';

export interface ExperiencesTabContentProps {
  isActive: boolean;
  isLastPair: boolean;
  isLoading?: boolean;
  experiences: ExperienceCard[];
  onExperienceClick?: (experienceId: string) => void;
}

export const ExperiencesTabContent: React.FC<ExperiencesTabContentProps> = ({
  isActive,
  isLastPair,
  isLoading,
  experiences,
  onExperienceClick,
}) => {
  return (
    <div
      style={{
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
        display: isActive ? 'block' : 'none', // Hide instead of unmounting
        paddingBottom: spacing[4],
      }}
    >
      {/* Show loading placeholder only for the last response pair when loading */}
      {isLastPair && isLoading ? (
        <ExperiencesLoadingPlaceholder pattern='search' count={6} />
      ) : experiences && experiences.length > 0 ? (
        <NexgoExperiencesSection
          experiences={experiences}
          onCardClick={onExperienceClick}
          cardSize='large'
        />
      ) : (
        <div
          style={{
            padding: spacing[8],
            textAlign: 'center',
            color: typographyColors.secondary,
            fontFamily: fontPrimary,
            fontSize: typography.size.base,
          }}
        >
          No experiences available at the moment.
        </div>
      )}
    </div>
  );
};
